module.exports = __webpack_public_path__ + "img/_video_minimize.ad0699f4.svg";